'use client';

import type { ValueFacet as ValueFacetType } from '../../types';
import ValueFacet from './ValueFacet';

export default function CombinedBooleanFacet({ facet }: { facet: ValueFacetType }) {
  return facet.values.map(value => (
    <ValueFacet
      facet={{
        ...facet,
        name: value.name,
        values: [value]
      }}
      key={value.name}
    />
  ));
}
